<template>
	<base-management-list v-slot="{ item }" :list="list" emptyImageName="empty-map" emptyMessage="등록된 배송지가 없습니다.">
		<shipping-address-item :item="item" @edit="$emit('edit', $event)" @delete="$emit('delete', $event)" />
	</base-management-list>
</template>

<script>
import BaseManagementList from '@/views/my-page/components/BaseManagementList.vue'
import ShippingAddressItem from '@/views/my-page/my-info/shipping-address/ShippingAddressItem.vue'

export default {
	name: 'ShippingAddressList',
	components: {
		BaseManagementList,
		ShippingAddressItem,
	},
	props: {
		list: {
			type: Array,
			default: () => [],
		},
	},
}
</script>

<style lang="scss" scoped></style>
